<template>
  <div>
    <treatment-history-detail
      :backRoute="backRoute"
      patientDetailRoute="NursePatientDetail"
      treatmentHistoryDetailRoute="NursePatientTreatmentDetail"
    />
  </div>
</template>
<script>
import PatientTreatmentHistoryDetails from '../../general-component/treatment-history/TreatmentDetails2.vue';
export default {
  name: 'NursePatientTreatmentDetails',
  components: {
    'treatment-history-detail': PatientTreatmentHistoryDetails,
  },
  data() {
    return {
      backRoute: 'NursePatientDetail',
    };
  },
  created() {
    if (this.$route.query.backRoute) {
      this.backRoute = this.$route.query.backRoute;
    }
  },
};
</script>
